(function ($) {
    /* HEADER */
    let body = $('body');

    function closeSiteMenu() {
        let pageWrap = $('.page-wrap'),
            siteMenu = $('.site-menu');

        if (pageWrap.length && siteMenu.length) {
            body.removeClass("opened-menu");
            pageWrap.removeClass("opened-menu");
            siteMenu.removeClass("opened-menu");
        }
    }

    let burgerBtn = $('header .burger-btn');
    if (burgerBtn.length) {
        burgerBtn.on('click', function () {
            let body = $('body'),
                pageWrap = $('.page-wrap'),
                siteMenu = $('.site-menu');

            if (pageWrap.length && siteMenu.length) {
                body.addClass("opened-menu");
                pageWrap.addClass("opened-menu");
                siteMenu.addClass("opened-menu");
            }
        });
    }

    let closeMenuBtn = $('.site-menu .close-btn');
    if (closeMenuBtn.length) {
        closeMenuBtn.on('click', function () {
            closeSiteMenu();
        });
    }

    // let siteMenuLink = $(".site-menu li a");
    // if (siteMenuLink.length) {
    //     siteMenuLink.on("click", function (e) {
    //         closeSiteMenu();
    //
    //         if (body.hasClass("home") && $(this).is('a[href*="#"]')) {
    //             e.preventDefault();
    //
    //             let additionalHeight = 20,
    //                 sectionId = $(this).attr("href").split("#")[1];
    //
    //             if ($(window).width() < '769') {
    //                 additionalHeight = 30;
    //             }
    //
    //             if ($(window).width() < '577') {
    //                 additionalHeight = 43;
    //             }
    //
    //             setTimeout(function () {
    //                 $("html, body").animate({
    //                     scrollTop: $("section#" + sectionId).offset().top + additionalHeight
    //                 }, 350);
    //             }, 200);
    //         }
    //     });
    // }
    /* HEADER */
})(jQuery);
